module.exports = __webpack_public_path__ + "static/media/TN-Women-Knit.dc37a6b8.svg";